import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import clsx from 'clsx'
import * as React from 'react'
import { Ref } from 'react'

import Styles from './Scrollable.module.scss'

interface ScrollAreaProps
  extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> {
  viewportRef?: Ref<HTMLDivElement>
  viewportClassName?: string
  scrollbarClassName?: string
  variant?: 'default' | 'notification'
}

const ScrollArea = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.Root>,
  ScrollAreaProps
>(
  (
    {
      variant = 'default',
      className,
      scrollbarClassName,
      viewportClassName,
      children,
      viewportRef,
      ...props
    },
    ref
  ) => (
    <ScrollAreaPrimitive.Root
      ref={ref}
      type="always"
      className={clsx(Styles.root, className)}
      {...props}>
      <ScrollAreaPrimitive.Viewport
        className={clsx(Styles.viewport, viewportClassName)}
        ref={viewportRef}>
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar className={scrollbarClassName} variant={variant} />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
)
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

interface IScrollBar
  extends React.ComponentPropsWithoutRef<
    typeof ScrollAreaPrimitive.ScrollAreaScrollbar
  > {
  variant: 'default' | 'notification'
}

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  IScrollBar
>(({ className, variant, orientation = 'vertical', ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={clsx(
      Styles.baseScrollbar,
      orientation === 'vertical' && Styles.vertical,
      orientation === 'horizontal' && Styles.horizontal,
      className
    )}
    {...props}>
    <ScrollAreaPrimitive.ScrollAreaThumb
      className={clsx(Styles.thumb, Styles[variant])}
    />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export { ScrollBar }
export default ScrollArea
